import { render, staticRenderFns } from "./LoginAndSignupModal.vue?vue&type=template&id=72052172"
import script from "./LoginAndSignupModal.vue?vue&type=script&lang=ts"
export * from "./LoginAndSignupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports